import {URL} from '@netx/core-next/url';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';

const logger = getPrefixedLogger('genericImage/utils');

export const ASSET_DEFAULT_ICON_TEST = /icons\/(.*)\.png/;

export enum Orientation {
	LANDSCAPE = 'landscape',
	PORTRAIT = 'portrait',
}

export type Dims = {width: number; height: number};

export const isDefaultIcon = (url?: string) =>
	url?.match(ASSET_DEFAULT_ICON_TEST); // || url === '' || url == null;

export const isPortrait = ({height, width}: Dims) => height > width;
export const isLandscape = ({height, width}: Dims) => width > height;
export const isSquare = ({height, width}: Dims) => width === height;

export const getOrientation = ({height, width}: Dims) =>
	height > width ? Orientation.PORTRAIT : Orientation.LANDSCAPE;

let watermarkNeedsChecking = true;
let watermarkAvailable: string | false = false;
let checkingWatermark: Promise<string | false> | undefined;
export const checkWatermarkAvailable = async () => {
	if (!watermarkNeedsChecking) return watermarkAvailable;
	if (checkingWatermark) return checkingWatermark;

	checkingWatermark = fetch(`${URL.watermark}?c=${Date.now()}`, {
		method: 'HEAD',
	})
		.then((response) => {
			if (response.ok) {
				watermarkAvailable = URL.watermark;
				logger.info('non destructive watermark > found');
				return URL.watermark;
			} else {
				logger.info('non destructive watermark > not found');
				return false;
			}
		})
		.catch(() => {
			logger.info('non destructive watermark > not found');
			return false;
		});

	return checkingWatermark;
};
// this is so hacky
dispatcher.on(
	'system:property:save',
	(prop: {label: string; value: string}) => {
		if (prop.label !== 'share.watermark.assetId') return;
		watermarkAvailable = false;
		watermarkNeedsChecking = true;
	},
);

/**
 * Fit image to container dimensions
 * @return Fitted image dimensions
 */
export const getFittedDims = (imageDims: Dims, containerDims: Dims) => {
	if (isPortrait(imageDims)) {
		const ratio = imageDims.width / imageDims.height;
		let newHeight = Math.min(imageDims.height, containerDims.height);
		let newWidth = newHeight * ratio;
		if (newWidth > containerDims.width) {
			newWidth = containerDims.width;
			newHeight = newWidth / ratio;
		}
		return {width: newWidth, height: newHeight};
	}
	const ratio = imageDims.height / imageDims.width;
	let newWidth = Math.min(imageDims.width, containerDims.width);
	let newHeight = newWidth * ratio;
	if (newHeight > containerDims.height) {
		newHeight = containerDims.height;
		newWidth = newHeight / ratio;
	}
	return {width: newWidth, height: newHeight};
};
